<template>
    <div class="participationRate" :id="Id">
        {{ type.fieldName }}
    </div>
</template>

<script>
export default {
    //import引入组件才能使用
    components: {},
    props: ['InjectData', 'Id', 'type'],
    data() {
        return {
            chartInstance: null
        };
    },
    // 计算属性
    computed: {},
    // 监听data中的数据变化
    watch: {
        InjectData: {
            handler() {
                this.Proportion();
            },
            deep: true,
        }
    },

    // 方法集合
    methods: {
        Proportion(data) {
            const suffixMap = {
                [`${this.type.fieldName}_85_up`]: '优秀',
                [`${this.type.fieldName}_70_85`]: '良好',
                [`${this.type.fieldName}_60_70`]: '合格',
                [`${this.type.fieldName}_0_60`]: '待提升',
            };
            let that = this;
            if (this.chartInstance) {
                this.chartInstance.dispose();
            }
            this.chartInstance = this.$echarts.init(document.getElementById(this.Id));
            this.chartInstance.setOption({
                dataZoom: [
                    {
                        type: 'inside',
                        startValue: 0,
                        endValue: 10,
                    },
                    {
                        type: 'slider', // 添加滚动条
                        show: true,
                        startValue: 0,
                        endValue: 10,
                        height: 15,
                        bottom: '10%',
                    }
                ],
                legend: {
                    show: true,
                    bottom: '3%',           // 距离容器底部 3%
                    left: 'center',
                    formatter: function (name) {
                        return (suffixMap[name] || '');
                    }, 
                },
                grid: {
                    top: '10%',
                    left: '1%',
                    right: '4%',
                    bottom: '18%',
                    containLabel: true
                },
                dataset: {
                    dimensions: ['name', `${this.type.fieldName}_85_up`, `${this.type.fieldName}_70_85`, `${this.type.fieldName}_60_70`, `${this.type.fieldName}_0_60`],
                    source: that.InjectData
                },
                xAxis: {
                    type: 'category',
                },
                yAxis: {
                    type: 'value',
                    axisLabel: {
                        formatter: function (value) {
                            return value; // 将值加上百分比符号
                        }
                    }
                },
                series: [
                    {
                        name: `${this.type.fieldName}_85_up`,
                        type: 'bar',
                        encode: { y: `${this.type.fieldName}_85_up` },
                        barWidth: 15,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                        }
                    },
                    {
                        name: `${this.type.fieldName}_70_85`,
                        type: 'bar',
                        barWidth: 15,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: `${this.type.fieldName}_70_85` },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                        }
                    },
                    {
                        name: `${this.type.fieldName}_60_70`,
                        type: 'bar',
                        barWidth: 15,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: `${this.type.fieldName}_60_70` },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                        }
                    },
                    {
                        name: `${this.type.fieldName}_0_60`,
                        type: 'bar',
                        barWidth: 15,
                        itemStyle: {
                            borderRadius: [4, 4, 0, 0],
                        },
                        encode: { y: `${this.type.fieldName}_0_60` },
                        label: {
                            show: true,
                            position: 'top',
                            color: '#000',
                            fontSize: 12,
                        }
                    },
                ]
            })
            window.addEventListener("resize", () => {
                if (this.chartInstance) {
                    this.chartInstance.resize();
                }
            });
        },
    },
    // 生命周期：挂载完成时（可以访问DOM元素）
    mounted() {
        if (this.InjectData) {
            this.Proportion();
        }
    },
    updated() {
        // 确保在DOM更新后重新绘制图表
        this.$nextTick(() => {
            if (this.InjectData) {
                this.Proportion();
            }
        });
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }

        // 移除resize事件监听器
        window.removeEventListener("resize", () => {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        });
    }
}
</script>
<style scoped lang="less">
.participationRate {
    width: 100%;
    height: 100%;
}
</style>